import application from "./application"
import users from "./users"
import plants from "./plants"
import errorList from "./errorList";
import {combineReducers} from "redux";

const reducer = combineReducers({application, users, plants, errorList});

export default reducer;
